module.exports = __webpack_public_path__ + "img/integratedMarketing_3.624600cb.png";